import { GetPageResponse } from "@store/features/crm/pageV2Slice";
import { Params } from "../../helpers";
import { getByPath } from "./utils";

export const createJsonCell = (
  field: {
    label?: string;
  },
  _params: Params,
  accessorPath: string,
  _pageData?: GetPageResponse,
) => {
  return {
    component: "NonEditable" as const,
    generateProps: (
      row: Record<string, unknown>,
      _index: number,
      _originalRow?: Record<string, unknown>,
    ) => {
      const value = getByPath(row, accessorPath);
      let label = "—";

      if (value !== null && value !== undefined) {
        if (typeof value === "object") {
          try {
            const jsonStr = JSON.stringify(value);
            label =
              jsonStr.length > 50 ? jsonStr.substring(0, 47) + "..." : jsonStr;
          } catch {
            label = "[Object]";
          }
        } else {
          label = String(value);
        }
      }

      return {
        label,
      };
    },
  };
};
